(function ($) {
  Drupal.behaviors.productComparisonFormatterV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $carousels = $('.js-product-brief-carousel-items', context);

      $carousels.each(function () {
        var $this = $(this);
        // autoplay settings
        var autoplay = $this.attr('data-slides-autoplay');

        if (typeof autoplay === 'undefined') {
          autoplay = false;
        } else {
          autoplay = true;
        }
        var settings = {
          autoplay: autoplay,
          autoplaySpeed: 5000,
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          centerPadding: '0px',
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '100px'
              }
            }
          ]
        };

        // Init this carousel with our settings
        $this.slick(settings);
      });
    },
    attached: false
  };
})(jQuery);
